<template>
    <article class="product-tile group relative flex h-full min-w-0 flex-col p-4 border-r border-b border-gray-200 sm:p-6">
        <div v-if="discount > 0"
             class="absolute top-4 left-4 z-10 bg-green-600 text-white w-16 rounded p-0.5 text-center font-bold sm:top-6 sm:left-6">
            -{{ discount }}%
        </div>

        <router-link :to="{name: 'product', params: {id: product_id}}"
                     class="block flex-shrink-0" :aria-label="`Zobacz produkt: ${name}`">
            <div class="rounded-lg overflow-hidden aspect-w-1 aspect-h-1 group-hover:opacity-75">
                <img :src="image_src" :alt="name" loading="lazy" decoding="async"
                     class="w-full h-full object-contain"/>
            </div>
        </router-link>

        <div class="mt-4 flex flex-1 flex-col text-center">
            <div class="w-full bg-gray-200 h-1">
                <div class="h-1" :class="stock_color" :style="{width: stock_bar + '%'}"></div>
            </div>

            <h3 class="product-name mt-3 text-sm font-medium leading-5 text-gray-900" :title="name">
                <router-link :to="{name: 'product', params: {id: product_id}}"
                             class="hover:text-indigo-600">{{ name }}</router-link>
            </h3>
            <p class="mt-1 text-xs text-gray-400 break-words">{{ ean }}</p>
            <button type="button"
                    class="mt-2 self-center max-w-full py-0.5 px-2 rounded-full text-xs font-medium bg-gray-100 text-gray-700 break-words"
                    @click="$router.push({name: 'shops', params: {id: department_id}})">
                {{ department_name }}
            </button>

            <div class="mt-auto pt-4">
                <p v-if="hasPromotion" class="text-gray-500 text-xs leading-4">
                    Obowiązuje od {{ promo_start }} do {{ promo_end }}
                </p>
                <p class="product-price mt-3 flex flex-wrap items-baseline justify-center gap-x-2 gap-y-1 text-base font-medium text-gray-900">
                    <span class="whitespace-nowrap">{{ formatPrice(hasPromotion ? promo_price : price) }}</span>
                    <span v-if="hasDiscount" class="whitespace-nowrap text-xs line-through text-gray-400">{{ formatPrice(price) }}</span>
                </p>
                <div class="mt-4 min-h-[2.75rem]">
                    <a v-if="online_shop_href" :href="online_shop_href"
                       class="flex min-h-[2.75rem] w-full items-center justify-center bg-gray-500 rounded-md py-3 px-2 text-sm font-medium leading-5 text-white whitespace-nowrap hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                        Kup online
                    </a>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
const priceFormatter = new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'});

export default {
    props: [
        'product_id',
        'category_id',
        'department_id',
        'department_name',
        'discount',
        'ean',
        'image_src',
        'name',
        'online_shop_href',
        'price',
        'promo_end',
        'promo_price',
        'promo_start',
        'stock_bar',
        'stock_color',
        'stock_name',
    ],
    computed: {
        hasPromotion() {
            return Number(this.promo_price) > 0;
        },
        hasDiscount() {
            return this.hasPromotion && Number(this.promo_price) < Number(this.price);
        },
    },
    methods: {
        formatPrice(value) {
            if (value === null || value === undefined || value === '') {
                return '—';
            }

            const amount = Number(value);
            return Number.isFinite(amount) ? priceFormatter.format(amount) : '—';
        },
    },
}
</script>

<style scoped>
.product-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    overflow-wrap: anywhere;
    min-height: 3.75rem;
}
</style>
